export default "__VITE_ASSET__69b5e4de__"